// extracted by mini-css-extract-plugin
module.exports = {"firstControlUnit":"_3aKBFp6DvWuvf48-49a1bw","flex":"_1m27zZSw22qweTlr9YaF7d","secondControlUnit":"Ch7WsnB01tFRj_dqQ8l7B"};